<template>
  <vuetify-app-minimal>
    <v-card class="mt-12 mx-auto px-8 py-8"
            elevation="4"
            max-width="1200">
      <v-card-text>
        <p class="display-1 text--primary">
        {{ $t('pages.about.title') }}
        </p>
        <div class="text--primary mission-text mt-12">
          {{ $t('pages.about.description') }} <v-btn icon target="_blank" alt="Google Translate link" color="primary" link href="https://translate.google.com/"><iconify-icon class="iconify" data-icon="mdi-google-translate"></iconify-icon></v-btn>.
        </div>
      </v-card-text>
    </v-card>
  </vuetify-app-minimal>
</template>

<script>
import VuetifyAppMinimal from '../components/VuetifyAppMinimal.vue'
  export default {
    components: {
      VuetifyAppMinimal,
    },
    metaInfo() {
      return {
        title: this.$i18n.t('pages.about.title'),
      }
    }
  }
</script>

<style>
  .mission-text {
    font-size: large;
    line-height: 2rem;
  }
</style>
